import { CallbackType, RequestHelper } from "./helper/module";

export class FormField {

    /** @type {any} */
    #txFormField;
    get txFormField() { return this.#txFormField; }

    /** @type {number=} */
    #start;
    get start() { return this.#start; }

    /** @type {number=} */
    #length;
    get length() { return this.#length; }

    /** @type {number=} */
    #id;
    get id() { return this.#id; }

    /** @type {string=} */
    #text;
    get text() { return this.#text; }

    /**
     * Wrapper für TXTextControl.FormField
     * @param {any} txFormField 
     */
    constructor(txFormField) {
        this.#txFormField = txFormField;
        this.#bindCallbacks();
    }

    /**
     * binding callback functions
     */
    #bindCallbacks() {
        this.#txFormField.getStart = this.#txFormField.getStart.bind(this.#txFormField);
        this.#txFormField.getLength = this.#txFormField.getLength.bind(this.#txFormField);
        this.#txFormField.getId = this.#txFormField.getID.bind(this.#txFormField);
        this.#txFormField.getText = this.#txFormField.getText.bind(this.#txFormField);
    }


    /**
    * Gets the first character position (one-based) of a text field
    * @returns {Promise<number>}
    */
    async getStart() {
        if (this.#start == null || typeof this.#start === 'undefined') {
            let result = await RequestHelper.Promise(this.txFormField.getStart,
                CallbackType.RequestNumberCallback,
                CallbackType.ErrorCallback);
            this.#start = result;
        }
        return /** @type {number} */(this.#start);
    }
    /**
    * Gets the first character position (one-based) of a text field
    * @returns {Promise<number>}
    */
    async getLength() {
        if (this.#length == null || typeof this.#length === 'undefined') {
            let result = await RequestHelper.Promise(this.txFormField.getLength,
                CallbackType.RequestNumberCallback,
                CallbackType.ErrorCallback);
            this.#length = result;
        }
        return /** @type {number} */(this.#length);
    }
    /**
    * Gets the ID of a text field
    * @returns {Promise<number>}
    */
    async getId() {
        if (this.#id == null || typeof this.#id === 'undefined') {
            let result = await RequestHelper.Promise(this.txFormField.getId,
                CallbackType.RequestNumberCallback,
                CallbackType.ErrorCallback);
            this.#id = result;
        }
        return /** @type {number} */(this.#id);
    }

    /**
    * Gets the text of a text field
    * @returns {Promise<string>}
    */
    async getText() {
        if (this.#text == null || typeof this.#text === 'undefined') {
            let result = await RequestHelper.Promise(this.txFormField.getText,
                CallbackType.RequestStringCallback,
                CallbackType.ErrorCallback);
            this.#text = result;
        }
        return /** @type {string} */(this.#text);
    }
}